import {Component, inject, OnInit} from '@angular/core';
import {ConceptService} from '../../core/concept.service';
import {PrimusRouterService} from '../../core/primus-router.service';
import {ConceptsContainer} from '../../core/definitions/concepts-container';

@Component({
    selector: 'app-admin-named-object',
    templateUrl: './admin-named-object.component.html',
    styleUrls: ['./admin-named-object.component.scss'],
    standalone: false
})
export class AdminNamedObjectComponent implements OnInit {
  // Injections
  private readonly conceptService: ConceptService = inject(ConceptService);
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);

  conceptsContainer: ConceptsContainer;
  parent;

  ngOnInit(): void {
    this.setAgentConceptsContainer().then();
    this.parent = {
      path: 'admin',
      adminType: 'named_object',
      hasSubMenus: true,
      target_params: {admin_type: 'named_object'},
      currentState: this.primusRouter.currentState()
    };
  }

  async setAgentConceptsContainer() {
    const conceptType = await this.conceptService.getConceptType('named_object');
    this.conceptService.setConceptsContainer(conceptType).then(conceptsContainer => {
      this.conceptsContainer = conceptsContainer;
      this.conceptsContainer.showLinkToObject = true;
    });

  }

}
